import { ArrowRight, Phone } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";
import { BookingDialog } from "@/components/site/BookingDialog";

export const CTABand = ({
  title = "Ready to go beyond conventional recruitment?",
  subtitle = "Book a confidential 15-minute briefing. We'll discuss your specific talent challenge and share relevant market intelligence.",
  label = "Let's talk",
}) => {
  return (
    <section className="relative overflow-hidden bg-[color:var(--bp-bg-2)] section-py" data-testid="cta-band">
      <div aria-hidden className="pointer-events-none absolute inset-0" style={{ background: "radial-gradient(680px 380px at 50% 0%, rgba(45,181,165,0.15), transparent 62%)" }} />
      <div className="container-bp relative">
        <Reveal>
          <div className="mx-auto max-w-3xl text-center">
            <p className="eyebrow inline-flex items-center justify-center gap-2 text-[color:var(--bp-teal)]">
              <span className="h-px w-8 bg-[color:var(--bp-teal)]" /> {label}
            </p>
            <h2 className="mt-6 font-display text-3xl font-semibold leading-[1.12] text-[color:var(--bp-cream)] sm:text-4xl lg:text-[2.8rem]">{title}</h2>
            <p className="mx-auto mt-5 max-w-xl text-[15px] leading-relaxed text-[color:var(--bp-text-muted)]">{subtitle}</p>
            <div className="mt-9 flex flex-col items-center justify-center gap-4 sm:flex-row">
              <BookingDialog
                trigger={
                  <button data-testid="ctaband-book-button" className="group inline-flex items-center justify-center gap-2 rounded-full bg-[color:var(--bp-teal)] px-8 py-4 text-sm font-semibold text-[color:var(--bp-bg)] shadow-[var(--shadow-soft)] transition-shadow hover:shadow-[var(--shadow-lift)]">
                    Book a Confidential Briefing
                    <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                  </button>
                }
              />
              <a href="tel:+37797000000" className="inline-flex items-center gap-2 rounded-full border border-[color:var(--bp-border)] px-7 py-4 text-sm font-medium text-[color:var(--bp-cream)] transition-colors hover:border-[color:var(--bp-teal)]">
                <Phone className="h-4 w-4 text-[color:var(--bp-teal)]" /> Speak to us
              </a>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
